<template>
  <div class="background-image" :style="computedStyle">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "BackgroundImage",
  props: {
    name: String,
    styles: String,
  },
  computed: {
    src() {
      return this.$store.getters[this.name].src;
    },
    computedStyle() {
      return `background-image: url(${this.src});` + this.styles;
    },
  },
};
</script>

<style scoped>
.background-image {
  width: 100%;
  height: auto;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}
</style>
